import script from "./PlayStoreFinder.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlayStoreFinder.vue?vue&type=script&setup=true&lang=ts"

import "./PlayStoreFinder.vue?vue&type=style&index=0&id=2707adc0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2707adc0"]])

export default __exports__